import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import RepaymentListUI from './RepaymentListUI.js'

class RepaymentListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      response: null,
      updateRemarksMode: false,
      updateDefaultsMode: false,
      updateInterestMode: false,
      updatePrincipalMode: false,
      selectedRepayment: null,
      //
      emiPaymentSubmitted: false,
      emiPaymentErrorList: null,
      selectedScheduledDate: null,
      //
      penaltySubmitted: false,
      paymentSubmitted: false,
      addRowMode: false,
      details: true,
      //
      downloadPenalChargeSubmitted: false
    }
  }

  render() {
    return (
      <RepaymentListUI
        context={this.props.context}
        errorList={this.state.errorList}
        response={this.state.response}
        repaymentList={this.props.repaymentList}
        chargeAmountsList={this.props.chargeAmountsList}
        totals={this.props.totals}
        onRefreshClick={this.props.onRefreshClick}
        account={this.props.account}
        loan={this.props.loan}
        //
        updateRemarksMode={this.state.updateRemarksMode}
        onUpdateRemarksClick={this.onUpdateRemarksClick}
        onCancelRemarksClick={() => { this.setState({ updateRemarksMode: false }) }}
        selectedRepayment={this.state.selectedRepayment}
        //
        updateOpExpensesMode={this.state.updateOpExpensesMode}
        onUpdateOpExpensesClick={this.onUpdateOpExpensesClick}
        onCancelOpExpensesClick={() => { this.setState({ updateOpExpensesMode: false }) }}
        //
        addChargeAmountMode={this.state.addChargeAmountMode}
        onAddChargeAmountClick={this.onAddChargeAmountClick}
        onCancelChargeAmountClick={() => { this.setState({ addChargeAmountMode: false }) }}
        //
        updateDefaultsMode={this.state.updateDefaultsMode}
        onUpdateDefaultsClick={this.onUpdateDefaultsClick}
        onCancelDefaultsClick={() => { this.setState({ updateDefaultsMode: false }) }}
        //
        updateInterestMode={this.state.updateInterestMode}
        onUpdateInterestClick={this.onUpdateInterestClick}
        onCancelInterestClick={() => { this.setState({ updateInterestMode: false }) }}
        //
        updatePrincipalMode={this.state.updatePrincipalMode}
        onUpdatePrincipalClick={this.onUpdatePrincipalClick}
        onCancelPrincipalClick={() => { this.setState({ updatePrincipalMode: false }) }}
        //
        downloadPenalChargeSubmitted={this.state.downloadPenalChargeSubmitted}
        onDownloadPenalChargeClick={this.onDownloadPenalChargeClick}
        //
        updateBalanceMode={this.state.updateBalanceMode}
        onUpdateBalanceClick={this.onUpdateBalanceClick}
        onCancelBalanceClick={() => { this.setState({ updateBalanceMode: false }) }}
        //
        onEmiPaymentClick={this.onEmiPaymentClick}
        emiPaymentSubmitted={this.state.emiPaymentSubmitted}
        emiPaymentErrorList={this.state.emiPaymentErrorList}
        selectedScheduledDate={this.state.selectedScheduledDate}
        //
        onPenaltyClick={this.onPenaltyClick}
        penaltySubmitted={this.state.penaltySubmitted}
        onPenaltyCancelClick={() => { this.setState({ penaltySubmitted: false }) }}
        //
        paymentSubmitted={this.state.paymentSubmitted}
        onPayClick={() => { this.setState({ paymentSubmitted: true }) }}
        onPayCancelClick={() => { this.setState({ paymentSubmitted: false }) }}
        //
        addRowMode={this.state.addRowMode}
        onAddRowClick={() => { this.setState({ addRowMode: true }) }}
        onAddRowCancel={() => { this.setState({ addRowMode: false }) }}
        //
        onDetailsClick={() => { this.setState({ details: !this.state.details }) }}
        details={this.state.details}
      />
    )
  }

  componentDidMount() {
  }

  onEmiPaymentClick = (event) => {
    let context = this.props.context
    let scheduledDate = event.currentTarget.getAttribute('data-row-id')
    this.setState({
      emiPaymentErrorList: [],
      emiPaymentSubmitted: true,
      selectedScheduledDate: scheduledDate
    })
    RestApiUtils.post(context, `/api/su/loans/${this.props.loan.loanId}/repayments/scheduledDates/${scheduledDate}/initialize`,
      this.onEmiPaymentClickCallback, {})
  }

  onEmiPaymentClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      emiPaymentErrorList: errorList,
      emiPaymentSubmitted: false,
      selectedScheduledDate: null
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onPenaltyClick = (event) => {
    let scheduledDate = event.currentTarget.getAttribute('data-row-id')
    this.setState({
      penaltySubmitted: true,
      selectedScheduledDate: scheduledDate
    })
  }

  onUpdateRemarksClick = (event) => {
    let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
    let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
    this.setState({ updateRemarksMode: true, selectedRepayment: selectedRepayment })
  }

  onUpdateOpExpensesClick = (event) => {
    let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
    let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
    this.setState({ updateOpExpensesMode: true, selectedRepayment: selectedRepayment })
  }

  onAddChargeAmountClick = (event) => {
    let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
    let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
    this.setState({ addChargeAmountMode: true, selectedRepayment: selectedRepayment })
  }

  onUpdateDefaultsClick = (event) => {
    let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
    let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
    this.setState({ updateDefaultsMode: true, selectedRepayment: selectedRepayment })
  }

  onUpdateInterestClick = (event) => {
    let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
    let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
    this.setState({ updateInterestMode: true, selectedRepayment: selectedRepayment })
  }

  onUpdatePrincipalClick = (event) => {
    let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
    let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
    this.setState({ updatePrincipalMode: true, selectedRepayment: selectedRepayment })
  }

  onUpdateBalanceClick = (event) => {
    let scheduledDateISO = event.currentTarget.getAttribute('data-scheduled-dateISO')
    let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDateISO == scheduledDateISO)[0]
    this.setState({ updateBalanceMode: true, selectedRepayment: selectedRepayment })
  }

  onDownloadPenalChargeClick = (event) => {
    let scheduledDateISO = event.currentTarget.getAttribute('data-scheduled-dateISO')
    this.setState({
      downloadErrorList: null,
      downloadPenalChargeSubmitted: true
    })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/scheduledDates/${scheduledDateISO}/penalCharges/invoice/fileDownloadSignedUrl`,
      this.onDownloadPenalChargeClickCallback, null, null
    )
  }

  onDownloadPenalChargeClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadPenalChargeSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export default RepaymentListSF
